module.exports = __webpack_public_path__ + "static/media/icon-hourglass-green.b0ba4638.svg";